import { PreguntaCargaDTO } from "@DTOS";
import { PreguntasTipoEnum } from "@shared/enums";
import { PREGUNTA_PADRE } from "../constantesImportador";
import { DatosPreguntaImportador } from "../DatosPreguntaImportador";
import { PreguntaImportador } from "../PreguntaImportador";

export class PreguntaGraphicalChoiceImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.GRAPHICAL_CHOICE;
    }

    public procesar(datos: DatosPreguntaImportador[]): PreguntaCargaDTO[] {
        const preguntas = super.procesar(datos);
        preguntas[PREGUNTA_PADRE].items.forEach(item => item.tieneImagen = true);
        return preguntas;
    }

    public testear(datos: DatosPreguntaImportador[], esUltima?: boolean): boolean {
        let pasoTests = super.testear(datos, esUltima);
        pasoTests = datos.slice(1).every(item => item.texto !== null) && pasoTests;
        return pasoTests;
    }
}
